import * as utils from './utils'
import * as utils_sendgrid from './utils_sendgrid'
import { User } from './User'
import { Account } from './Account'
import { Auction } from './Auction'

const DEBUGGING = process.env.NODE_ENV === 'development'

export type howJoinedTypes = 'normal' | 'invitedBasic'

export interface QuizResult {
  quizId: string,
  numCorrect: number,
  earnedBonus: boolean
}

export class TokenUser extends User {
  protected static ALLOW_UNEXPECTED_FIELDS: boolean = false   // cuz we set User to true

  public howJoined: howJoinedTypes = null
  public lastTimeEmailedType: { [emailType: string]: number } = {}
  public unsubscribedFromSpecificType: { [emailType: string]: boolean } = {}

  public lastSendgridEvent: utils_sendgrid.sendgridEvent
  public numEmailBouncesOrDrops: number = 0
  public numEmailOpens: number = 0
  public numEmailClicks: number = 0
  public numEmailSends: number = 0

  public linkedAccountId: string = null
  public linkedFlowAddress: string = null
  public topShotVerified: boolean = null    // whether or not their flowAddress/lowercaseUsername/username have been verified
  public priceToListForVerification: number = null

  public telegramConfirmed: boolean = null
  public telegramChatId: number = null
  public telegramUsername: number = null
  public telegramConfirmationCode: string = null

  // discord stuff added Sept 6, 2021
  public discordGuildMember: any = null
  public discordAboutText: string = null

  // quiz stuff added Sept 29, 2021
  // quiz stuff added Sept 29, 2021
  public quizResults: QuizResult[] = null
  public twitterScreenName: string = null     // collected from quiz bonus submission, so not verified

  // giveaway stuff added Feb 5, 2021
  public giveaways: string[] = null

  // we don't need to send these to segment because segment captures these automatically, but we capture these ourselves too for our own DB
  public utm_source: string = null
  public utm_campaign: string = null
  public utm_medium: string = null
  public utm_content: string = null
  public utm_term: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  // client-only field not meant to be stored in db - utils_mongo.insertOne() and utils_mongo.insertMany() are instrumented to do this
  public _temp: { account?: Account } = {}

  constructor(po?: object) {
    super(null)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  // on both client and server side
  public getTraitObjectForSegment(): any {
    return {
      // segment reserved traits
      createdAt: this.created.toISOString(),
      email: this.email,
      username: this._temp && this._temp.account ? this._temp.account.username : null,
      id: this.getIdAsString(),

      // our own traits
      emailVerified: this.emailVerified,
      howJoined: this.howJoined,
      invitedBy: this.invitedBy,
      numInvited: this.invited.length,
      lastSeen: (this.lastSeen) ? this.lastSeen.toISOString() : null,
      source: this.source,
      fullyRegistered: this.fullyRegistered,
      numEmailTypesUnsubscribed: Object.keys(this.unsubscribedFromSpecificType).length,
      activityScore: this.activityScore(),
      flowAddress: this._temp && this._temp.account ? this._temp.account.flowAddress : null
    }
  }

  public isSafe(): boolean {
    // if (this.email) return false -- cuz we send it separately and add it in if user is authenticated as the user
    if (this.lastSendgridEvent) return false
    if (this.numEmailBouncesOrDrops) return false
    if (this.numEmailOpens) return false
    if (this.numEmailClicks) return false
    if (this.numEmailSends) return false
    if (this.utm_source) return false
    if (this.utm_campaign) return false
    if (this.utm_medium) return false
    if (this.utm_content) return false
    if (this.utm_term) return false
    if (this.telegramChatId) return false
    if (this.telegramConfirmationCode) return false
    if (this.telegramUsername) return false
    if (this.quizResults) return false
    if (this.giveaways) return false
    if (!super.isSafe()) return false
    return true
    
  }
  public activityScore(): number {
    return this.invited.length
  }

  public accountOldEnoughToPostAuctions(): boolean {
    const nowTimeInMS: number = new Date().getTime()
    const createdTimeInMS: number = this.created.getTime()
    const auctionLaunchDate: Date = new Date(Auction.LAUNCH_DATE_ISO_STRING)
    if (this.created < auctionLaunchDate) return true                   // signed up to LT before auction launch
    if (nowTimeInMS - createdTimeInMS > 30 * 86400 * 1000) return true  // signed up to LT 30+ days algo
    return false
  }

  public daysAgoSignedUp(): number {
    const nowTimeInMS: number = new Date().getTime()
    const createdTimeInMS: number = this.created.getTime()
    const signedUpAgoInMS: number = nowTimeInMS - createdTimeInMS
    return signedUpAgoInMS / (86400 * 1000)
  }

}
